/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Absolutely — anything you can type. Names, chores, films, restaurants or yes/no all work.`)
};

const es_dw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por supuesto — cualquier cosa que puedas escribir. Nombres, tareas, películas, restaurantes o sí/no, todo funciona.`)
};

const de_dw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf jeden Fall — alles, was du eingeben kannst. Namen, Aufgaben, Filme, Restaurants oder Ja/Nein funktionieren alle.`)
};

const nl_dw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Absoluut — alles wat je kunt typen. Namen, klusjes, films, restaurants of ja/nee, het werkt allemaal.`)
};

const fr_dw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Absolument — tout ce que vous pouvez taper. Noms, corvées, films, restaurants ou oui/non fonctionnent tous.`)
};

const it_dw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Certamente — qualsiasi cosa tu possa digitare. Nomi, faccende, film, ristoranti o sì/no funzionano tutti.`)
};

const pt_br2_dw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claro — qualquer coisa que você conseguir digitar. Nomes, tarefas domésticas, filmes, restaurantes ou sim/não, tudo funciona.`)
};

const pt_dw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claro — qualquer coisa que possa escrever. Nomes, tarefas domésticas, filmes, restaurantes ou sim/não funcionam todos.`)
};

const ja_dw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`もちろんです — 入力できるものなら何でも使えます。名前、家事、映画、レストラン、はい/いいえなど、すべて対応しています。`)
};

const zh_dw_faq_a3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当然可以——任何你能输入的内容都行。姓名、家务、电影、餐厅或是/否选项都可以使用。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dw_faq_a3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dw_faq_a3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dw_faq_a3", locale)
	if (locale === "en") return en_dw_faq_a3(inputs)
	if (locale === "es") return es_dw_faq_a3(inputs)
	if (locale === "de") return de_dw_faq_a3(inputs)
	if (locale === "nl") return nl_dw_faq_a3(inputs)
	if (locale === "fr") return fr_dw_faq_a3(inputs)
	if (locale === "it") return it_dw_faq_a3(inputs)
	if (locale === "pt-BR") return pt_br2_dw_faq_a3(inputs)
	if (locale === "pt") return pt_dw_faq_a3(inputs)
	if (locale === "ja") return ja_dw_faq_a3(inputs)
	return zh_dw_faq_a3(inputs)
};